var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRosterReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.542 5.10645V14.4002C31.542 15.6603 31.542 16.2903 31.7872 16.7716C32.0029 17.195 32.3471 17.5392 32.7705 17.7549C33.2518 18.0002 33.8819 18.0002 35.142 18.0002H44.4357M18.042 33.75V40.5M36.042 29.25V40.5M27.042 23.625V40.5M45.042 22.4735V38.7C45.042 42.4804 45.042 44.3705 44.3063 45.8144C43.6591 47.0845 42.6265 48.1171 41.3564 48.7643C39.9125 49.5 38.0223 49.5 34.242 49.5H19.842C16.0616 49.5 14.1715 49.5 12.7276 48.7643C11.4575 48.1171 10.4248 47.0845 9.7777 45.8144C9.04199 44.3705 9.04199 42.4804 9.04199 38.7V15.3C9.04199 11.5196 9.04199 9.62947 9.7777 8.18556C10.4248 6.91547 11.4575 5.88285 12.7276 5.23571C14.1715 4.5 16.0616 4.5 19.842 4.5H27.0685C28.7195 4.5 29.545 4.5 30.3218 4.6865C31.0106 4.85186 31.669 5.12459 32.2729 5.49468C32.9541 5.91211 33.5378 6.49582 34.7052 7.66325L41.8787 14.8368C43.0462 16.0042 43.6299 16.5879 44.0473 17.2691C44.4174 17.873 44.6901 18.5314 44.8555 19.2202C45.042 19.997 45.042 20.8225 45.042 22.4735Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRosterReports);
export default __webpack_public_path__ + "static/media/RosterReports.a7417ab229076367281e0c4ac405a979.svg";
export { ForwardRef as ReactComponent };